const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = 'Financial'
const Supervisor = 'Supervisor'
const Clerk = 'Clerk'
const Seller = 'Seller'
const YardOperator = 'YardOperator'
const Assistant = 'Assistant'
const SalesExecutive = 'SalesExecutive'
const CreditAnalyst = 'CreditAnalyst'
const Logistics = 'Logistics'

const clientRegisterRoutes = [
  {
    path: '/client_portifolios/create',
    name: 'CreateClientPortfolios',
    meta: { 
      auth: true, 
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
    component: () => import('@/_backoffice/_registrations/components/client_portfolio/CreateClientPortfolios.vue'),
  },
  {
    path: '/client_portifolios',
    name: 'ClientPortfolios',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Logistics],
    },
    component: () => import('@/_backoffice/_registrations/pages/ClientsPortfolios.vue'),
    children:[
      {
        path: "transfer_clients",
        name: "TransferClientsToBetweenClientPortfolios",
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics],
        },
        component: () => import("@/_backoffice/_registrations/components/client_portfolio/TransferClientsToBetweenClientPortfolios.vue")
      },
      {
        path: ":id/:kind",
        name: "ShowPortfolioClientsAndEmployees",
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics],
        },
        component: () => import("@/_backoffice/_registrations/components/client_portfolio/DialogShowClientsAndEmployees.vue")
      },
      {
        path: ":id",
        name: "ShowClientPortifolio",
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Logistics],
        },
        component: () => import("@/_backoffice/_registrations/components/client_portfolio/ShowClientPortfolio.vue")
      },
    ]
  },

]


export default clientRegisterRoutes
